export default __webpack_public_path__ + "static/gear_w.ab5d81462861c9899b9feb7d3e68edbb.svg";